import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Img from '../../../Utils/Ratio';
import profileGreeting from '../../../assets/images/dashboard/profile-greeting/bg.png';
import { AndroidAndIOS, AvailableInYour, CheckNow, InstallAppUpgradeSystem, Smartphone } from '../../../Constant';
import { H3, H4, H5, P } from '../../../AbstractElements';
const WelcomeCard = () => {
  return (
    <>
      <Col xl='4' md='6' className='box-col-50 xl-50'>
        <Card className='profile-greeting'>
          <CardBody className='card-body'>
            <Img className='img-fluid bg-img bg-img-cover' src={profileGreeting} alt='bg image' />
            <div>
              <H3>{AvailableInYour} </H3>
              <H4>{Smartphone}</H4>
              <H5>{AndroidAndIOS}</H5>
              <P> {InstallAppUpgradeSystem}</P>
              <a className='btn btn-primary' rel='noreferrer' target='_blank' href='https://themeforest.net/user/pixelstrap/portfolio'>
                {CheckNow}
              </a>
            </div>
          </CardBody>
          <div className='shap-block'>
            <div className='rounded-shap'>
              <i />
              <i />
              <i> </i>
            </div>
          </div>
        </Card>
      </Col>
    </>
  );
};

export default WelcomeCard;
